export default __webpack_public_path__ + "static/media/login-video-2.a0dddada.mp4";